export default __webpack_public_path__ + "static/media/Flag_of_India.b4edf60f.svg";